module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9S1fJ"))).then(() => parcelRequire('d0iPb'));